export default {
  /* A */
  add: '追加',
  all: '全て',
  admin: '管理画面',
  alias: 'エイリアス',
  apply: '適用',
  agent: '代理',
  agents: '代理',
  appKey: 'ユーザー名',
  avatar: 'アバター',
  amount: '金額',
  action: '操作',
  agentId: '代理',
  approve: '承認',
  activate: 'アクティベート',
  autoSync: '自動同期',
  approval: '承認',
  approved: '承認済み',
  allCache: 'すべてのキャッシュ',
  activated: 'アクティベート済み',
  accountId: 'トレードシステムユーザーID',
  appSecret: 'パスワード',
  agentName: '代理名',
  amountInfo: '金額情報',
  addressInfo: '住所情報',
  autoChannel: '自動',
  addressDetail: '住所詳細',
  accountAmount: 'アカウント残高',
  approvalStatus: '承認ステータス',
  accountCurrency: 'アカウント通貨',
  alreadyLoggedIn: 'すでにログイン済み',
  approvalProcess: '承認プロセス',
  accountActivate: 'アカウントをアクティベート',
  accountActivated: 'アカウントがアクティベートされましたか',
  appliedDate: '適用日',
  approvalComment: '承認コメント',
  approveAndWithdraw: 'お金の受け渡しと引き出し',
  alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
  // accountRiskLevel: '账户风险等级',
  allSelectedCount: '全て（{count}）',
  actualAccountAmount: '実際のアカウント残高',
  actualDepositAmount: '実際の入金額',
  accountDepositAmount: 'トレードアカウントへの入金額',
  accountWithdrawalAmount: '引き出し金額',
  apiResultMsg: 'API結果メッセージ',
  android: 'Android',
  androidLink: 'Android Link',
  accountInfo: 'Account Info',

  /* B */
  back: '戻る',
  bank: '銀行',
  branch: '支店',
  backTo: 'ログインに戻る',
  bankNo: '銀行番号',
  backTop: 'トップに戻る',
  balance: '残高',
  bankCard: '銀行カード',
  bordered: '枠線',
  basicInfo: '基本情報',
  batchSize: 'バッチサイズ',
  backToLogin: 'ログインに戻る',
  backToPrevious: '前に戻る',
  backToPreviousStep: '前の',
  backToRegister: '登録に戻る',
  bankBranch: '口座開設支店名',
  bankAccount: '銀行口座',
  baseCurrency: '基本通貨',
  branchAddress: '支店住所',
  bankAccountName: '銀行口座名',
  bankNameOrNetwork: '銀行名 / ネットワーク',
  bankCardInfo: 'Bank Card Info',
  bankCardId: 'Bank Card ID',

  /* C */
  csv: 'CSV',
  copy: 'コピー',
  check: 'チェック',
  close: '閉じる',
  cancel: 'キャンセル',
  create: '作成',
  confirm: '確認',
  checked: 'チェック済み',
  comment: 'コメント',
  countryOrRegion: '国または地域',
  created: '作成済み',
  channel: 'チャンネル',
  closeAll: 'すべて閉じる',
  customer: '顧客',
  copyLink: 'リンクをコピー',
  countries: '国',
  createdBy: '作成者',
  childType: '子供のタイプ',
  cancelDate: 'キャンセル日',
  cardholder: 'カードホルダー',
  customerId: '顧客ID',
  configName: '変数名',
  configDesc: '変数の説明',
  cardDetail: '銀行カード',
  conversion: '変換',
  cashflowKid: 'トランザクションシステムフローID',
  channelName: 'チャンネル名',
  configValue: '変数の値',
  createdDate: '作成日',
  currencyType: '国内外通貨口座',
  channelError: 'チャンネルエラー',
  customerInfo: '顧客情報',
  customerData: '顧客データ',
  currentCache: '現在のキャッシュ',
  closeAllTabs: 'すべてのタブを閉じる',
  createdBefore: '以前に作成',
  cryptoNetwork: '暗号ネットワーク',
  clearAllCache: 'すべてのキャッシュをクリア',
  contactContent: '内容',
  forgotPassword: 'パスワードを忘れました',
  changePassword: 'パスワード変更',
  customerVerify: '顧客認証',
  closeOtherTabs: '他のタブを閉じる',
  closeRightTabs: '右のタブを閉じる',
  createAccounts: 'アカウントを作成',
  certificateNo: '証明書番号',
  confirmationMin: '最小確認回数',
  confirmPassword: 'パスワードを確認',
  closeCurrentTab: '現在のタブを閉じる',
  chineseSimplified: '簡体字中国語',
  changePwdSucceess: 'パスワードの変更に成功しました',
  customerFeeAmount: '顧客手数料',
  customerCurrencies: '顧客通貨',
  customerDepositFlow: '顧客の入金フロー',
  customerVerifyFlowId: '現在の検証ID',
  customerIdentificationId: '身分証明ID',
  cancelTransaction: '取引をキャンセル',
  cancelTransactionPopupTitle: 'この操作は取り消すことができません。この取引を放棄しますか？',
  captchaImageErrorMsg: 'エラーが発生しました。ここをクリックしてリフレッシュしてください',
  captchaText: 'キャプチャ',
  completed: '完了',
  confirmDetail: '詳細を確認',
  confirmProof: '確認証',
  confirmComplete: '完了の確認',
  confirmRecvPopupTitle: 'この操作は取り消すことはできません。この取引を受け取ったことを確認しますか？',
  confirmTransaction: '取引を確認',
  confirmTransactionPopupTitle: 'この操作は取り消すことができません。この取引を完了しましたか？',
  currentChannelNotAvailableAndSetAsAuto: '現在のチャンネルは利用できません。自動に切り替えました',

  /*D*/
  dob: '生年月日',
  desc: '説明',
  detail: '詳細',
  details: '詳細',
  deposit: '入金',
  depositHistory: '入金履歴',
  download: 'ダウンロード',
  demoSystem: 'デモシステム',
  demoAppKey: 'デモユーザー名',
  description: '説明',
  demoAppSecret: 'デモパスワード',
  depositAmount: '入金金額',
  depositDetail: '入金詳細',
  depositVerify: '入金確認',
  depositRemark: '送金メモ',
  depositFlowId: '入金ID',
  depositCurrency: '入金通貨',
  depositApproval: '入金承認',
  depositInfo: 'Deposit Info',

  /* E */
  en: '英語',
  env: '環境',
  edit: '編集',
  enum: '列挙',
  empty: '空',
  enable: '有効化',
  enabled: '有効',
  existing: '既存',
  equalZero: 'ゼロに等しい',
  expandAll: 'すべて展開',
  emailDetail: 'メール詳細',
  engFullName: '英語フルネーム',
  engShortName: '英語略名',
  emailVerified: 'メール認証',
  encryptedId: '上流の注文番号',
  expectedWithdrawalAmount: '予想出金額',
  exclusiveAccountId: 'Exclusive Account ID',

  /* F */
  fee: '手数料',
  force: '強制',
  fxRate: '為替レート詳細',
  failure: '失敗',
  feeInfo: '手数料情報',
  flowInfo: '申請情報',
  fullName: '氏名',
  forceCancel: '強制キャンセル',
  familyNameEn: '姓',
  forceConfirm: '強制確認',
  frozenAmount: '凍結金額',
  fxCurrencyPair: '外貨ペア',
  fxRateTemplate: 'FXレートテンプレート',
  fatcaSignedDate: 'FATCA署名日',
  fxRateTemplateId: 'FXレートテンプレートID',
  forgotNoticeTitle1: 'パスワードのリセットリンクがメールに送信されました',
  forgotNoticeTitle2: 'メールでリセットしてください！',
  forgotNoticeTitle3: 'すでにメールにログインし、リンクをクリックしましたか？',

  /* G */
  goRegister: '今すぐ登録',
  gotoVerify: '認証に移動',
  goDeposit: '入金に移動',
  goLogin: 'アプリケーションプラットフォームにアクセスしてログインしてください',
  giinTaxNo: 'GIIN税番号',
  guestForbidden: 'ゲストログインを無効にする',
  givenNameEn: '名前',
  greaterThan: '{number}より大きい',
  greaterThanZero: 'ゼロより大きい',
  gatewayLoginUsername: 'ゲートウェイログインユーザー名',
  gatewayFeeAmount: 'Gateway Estimate Fee',

  /* H */
  hide: '非表示',
  help: 'ヘルプ',
  hours: '時間',
  hasRemainingAmount: '残高あり',

  /* I */
  id: 'ID',
  it: '機関',
  itId: '機関',
  items: 'アイテム',
  itName: '機関名',
  inviter: '紹介者',
  identity: 'アイデンティティ',
  itReceive: '受取口座',
  invalidUrl: '無効なURL',
  inputAmount: '金額入力',
  inputPaymentInfo: '支払情報入力',
  inputPaymentMethod: '金額計算',
  itReceiveAccount: '機関受取アカウント',
  itReceiveId: '機関受取アカウントID',
  internetUser: 'インターネットユーザー',
  institutionId: '機関ID',
  identifyDetail: 'アイデンティティ認証',
  identification: 'アイデンティティ',
  identityVerify: 'アイデンティティ認証',
  itReceiveMethod: '機関受取方法',
  itReceiveNumber: '機関受取アカウント',
  identificationId: 'アイデンティティID',
  identificationType: 'IDタイプ',
  identificationInfo: 'アイデンティティ情報',
  identificationNumber: 'ID番号',
  identificationStep1Title: '個人情報',
  identificationStep1Name: '身分証明書に記載されている名前（ローマ字）を入力してください',
  identificationStep2OnlyTaxInCountry: '私は上記の国で納税しています',
  identificationStep2SameBirthNationality: '私の出生地と国籍は上記の国と同じです',
  identificationStep2NonUSResident: '私は米国の市民でも米国の納税居住者でもありません',
  identificationStep4Title: '投資の知識',
  identificationStep4Desc:
    '金融商品に関するあなたの知識レベルを評価する必要があります。提供された回答が正しくない場合、評価が不合格になる可能性があります。慎重に回答を考えてください。',
  identificationStep4KlMaxInvestment:
    'あなたは$3,000を投資しました。レバレッジは1:100です（レバレッジを使用した場合）。あなたが取引できる最大のポジションの価値は何ですか？',
  identificationStep4KlTrigger: 'ストップロスオーダーがトリガーされる場合',
  identificationStep4KlAutoClose: '未解決のポジションが次の場合に自動的にクローズされる可能性があります（追加の保証金など）',
  identificationStep5Title1: '適格性評価',
  identificationStep5Title2: '取引経験',
  identificationStep5Desc:
    '金融商品に関するあなたの知識レベルを評価する必要があります。提供された回答が正しくない場合、評価が不合格になる可能性があります。慎重に回答を考えてください。',
  identificationStep5AxTradingCount:
    '過去1年間にどのような取引経験がありますか？（専門的なアドバイスは受けていない）株、債券、商品',
  identificationStep5AxOtcCount: 'OTC取引のデリバティブ製品（レバレッジCFD、外国為替、差金決済、スプレッドベット）',
  identificationStep5AxOtcLeverage: '通常、上記のOTCデリバティブ商品の取引に使用されるレバレッジは何ですか？',
  identificationStep6Title: '専門的な経験',
  identificationStep6ExpHasFinanceEducation:
    '過去3年間、金融サービス業界での教育、資格、および/または業務経験（レバレッジ取引を理解する必要がある仕事）を持っていますか？',
  identificationStep6ExpFinanceEducation:
    'あなたの教育背景、専門的な資格、および/または金融サービス業界での業務経験についての詳細情報を提供してください',
  identificationStep7Title: '雇用情報',
  identificationStep7Occupation: 'あなたの雇用状況はどうですか？',
  identificationStep7Industry: 'あなたはどの業界で働いていますか？',
  identificationStep8Title: '財務情報',
  identificationStep8finAnnualIncome: '年収',
  identificationStep8finSavingsInvestment: '貯金と投資（不動産を含まない）',
  identificationStep8finIncomeSource: '取引資金の主要な源泉',
  identificationStep8maxInvestmentLoss: '毎年どのくらいの金額を取引にリスクを取ることができますか？',
  identificationStep9Title: '取引の概要',
  identificationStep9TradingFrequency: '取引頻度はどのくらいですか？',
  identificationStep9DepositMethod: 'アカウントへの入金方法は何ですか？',
  identificationStep9AcknowledgeTradingRisk:
    '私は、{name}での取引がさまざまなアセットの差分契約商品の売買であることを理解し、価格変動がすべての人に適しているわけではなく、私のように高いリスク耐性を持つ人だけが取引できることを認識しています。',
  identificationStep10Title: '利用規約',
  identificationStep10ConsentAgreement: '私は{name}の利用規約を詳しく読み、承諾します',
  identificationStep10Agreement1: '注文執行ポリシー',
  identificationStep10Agreement2: 'リスク開示のお知らせ',
  identificationStep10Agreement3: 'プライバシーポリシー',
  identificationStep10Agreement4: '重要な情報文書',
  isExclusive: 'Is Exclusive',
  ios: 'IOS',
  iosLink: 'IOS Link',
  ifsc: 'IFSCキー',

  /* J */
  jurisdiction: '管轄区',

  /* K */
  kv: 'トランザクションシステムレコードバージョン',
  key: 'キー',

  /* L */
  list: 'リスト',
  lock: 'ロック',
  line1: '住所1',
  line2: '住所2',
  login: 'ログイン',
  logout: 'ログアウト',
  locked: 'ロック済み',
  loginId: 'ログインID',
  language: '言語',
  lockTime: 'Lock Time',
  liveSystem: 'ライブシステム',
  loginQuick: 'クイックログイン',
  loginUsername: 'メールアドレスを入力してください',
  loginPassword: 'ログインパスワードを入力してください',
  lastModifiedBy: '最終更新者',
  lastModifiedDate: '最終更新日',
  lastAutoSyncTime: '自動同期時間',
  lookBackInterval: '過去の期間',
  localDepositAmount: '入金金額（現地通貨）',

  /* M */
  mark: 'マーク',
  more: 'もっと見る',
  mobile: '携帯電話',
  minute: '分',
  minutes: '分',
  merchantName: '商店名',
  middleNameEn: 'ミドルネーム',
  mobileDetail: '携帯電話',
  manualRefresh: '手動更新',
  myReceiveAccount: '受け取りアカウント',
  myReceiveBank: '受け取り銀行',
  myReceiveNumber: '受け取りアカウント番号',
  maxAutoConfirmAmount: '最大自動確認金額',
  minTransactionAmount: '最小取引金額',
  maxTransactionAmount: '最大取引金額',
  macX86Desktop: 'Mac(x86) Desktop',
  macX86DesktopLink: 'Mac(x86) Desktop Link',
  macArmDesktop: 'Mac(Arm) Desktop',
  macArmDesktopLink: 'Mac(Arm) Desktop Link',

  /* N */
  no: 'いいえ',
  name: '名前',
  number: 'アカウント',
  notEnabled: '無効',
  notifyLang: '通知言語',
  notNecessary: '不要',
  networkUrls: 'ネットワークURL',
  newPassword: '新しいパスワード',
  neverExpire: '期限切れなし',
  noDataFound: 'データが見つかりません',
  notifyEmail: '通知メール',
  nextStep: '次のステップ',
  noAccount: 'アカウントを持っていませんか？',
  noTransactionHint: '転送履歴はありません、お待ちください',
  noAvailableChannel: '利用可能なチャネルがありません、後でもう一度試してください',

  /* O */
  on: 'オン',
  or: 'または',
  off: 'オフ',
  operator: 'オペレーター',
  oldPassword: '古いパスワード',

  /* P */
  px: 'ピクセル',
  proof: '証拠',
  people: '人',
  profile: '個人情報',
  process: 'プロセス',
  payType: '支払いタイプ',
  pageSize: 'ページサイズ',
  province: '州',
  password: 'パスワード',
  postCode: '郵便番号',
  processed: '処理済み',
  processes: 'プロセス',
  profession: '職業',
  plzRelogin: '再ログインしてください',
  phoneDetail: '電話番号',
  parentAgent: '親代理店',
  preconditions: '前提条件',
  paymentChannel: '支払いチャネル',
  paymentGateway: '支払いゲートウェイ',
  paymentRouting: '支払いチャネルルーティング',
  processComplete: 'プロセス完了',
  paymentRoutingId: '支払いチャネルルーティングID',
  passwordResetNoticeTitle: 'パスワードの変更が成功しました',
  passwordResetFailTitle: 'にリダイレクトします',
  paymentCurrency: '支払い通貨',
  pleaseChooseItReceiveAccount: '受け取り方法',
  pleaseChoosePayment: '支払い方法',
  pleaseSignIn: 'ユーザー名とパスワードを入力してください',
  pleaseSignUp: '登録するユーザー名とパスワードを入力してください',
  pleaseVerifySoon: '認証をできるだけ早く完了してください',
  previousStep: '前のステップ',
  planDepositAmount: '予定の入金額',
  paymentFeeModel: '上流手数料モデル',
  paymentFeeValue: '上流手数料設定値',
  paymentFeeCurrency: '上流手数料通貨',
  plzReloginWithNewPwd: '新しいパスワードで再ログインしてください',
  paymentFeeInfo: '上流手数料情報',
  paymentOrderStatus: '注文の状況',
  providerType: 'プロバイダーの種類',
  pleaseSelectApprovalStatus: 'Please select approvalStatus',
  paymentFeeAmount: 'Payment Estimate Fee',
  processing: 'Processing',
  pixType: 'PIX タイプ',
  pixKey: 'PIX キー',

  /* Q */
  qrCode: 'QRコード',
  quoteCurrency: '見積もり通貨',

  /* R */
  rate: '為替レート',
  role: '役割',
  roles: '役割',
  reset: 'リセット',
  region: '地域',
  result: '結果',
  roleId: '役割',
  remove: '削除',
  reject: '拒否',
  reason: '理由',
  receive: '受け取る',
  refresh: '更新',
  retract: '取り消す',
  regDate: '登録日',
  register: '登録',
  receiver: '受信者',
  resource: 'リソース',
  retryMail: 'メール再送',
  resend: '再送信',
  receiverId: '受信者ID',
  refreshAll: 'すべて更新',
  regCustomer: 'アカウント登録',
  rateDetails: '為替レートの詳細',
  receiverName: '受信者の名前',
  receiverRole: '受信者の役割',
  receiveMethod: '受け取り方法',
  receiveNumber: 'アカウント番号',
  resetPassword: 'パスワードをリセット',
  receiverNumber: '受信者のアカウント番号',
  receiverNumberCpf: '受信者のアカウント番号',
  receiverNumberPhone: '電話番号',
  receiverNumberEmail: '電子メール',
  receiverNumberEvp: 'バーチャルペイメントアドレス',
  receiverAccount: '受信アカウント',
  receiveCurrency: '受け取り通貨',
  receiverNetwork: '受信ネットワーク',
  remainingAmount: '残高',
  recoverPassword: 'パスワードを回復',
  receivingCurrency: '受け取り通貨',
  registerNoAgentAlert: '代理店に登録リンクを提供してください',
  registerNoticeTitle: 'メールでアカウントをアクティブ化してください',
  registerVerifyTitle1: '登録完了！',
  registerVerifyTitle2: 'もう一度',
  resendActiveMail: '認証メールを再送信',
  recoverMailPassword: 'パスワードを回復するメールアドレスを入力してください',
  recoverPhonePassword: 'パスワードを回復する電話番号を入力してください',
  restoreDefaultSettings: 'デフォルト設定に戻す',
  receiverNumberOrAddress: '受信者のアカウント番号/住所',
  registerOtherWay: 'または以下の方法で登録',
  registerAgreementTitle1: '同意します',
  registerAgreementTitle2: '利用規約',
  registerPleaseAgree: '規約に同意してください',

  /* S */
  sex: '性別',
  show: '表示',
  step: 'ステップ',
  sync: '同期',
  send: '送信',
  synced: '同期済み',
  source: 'ソース',
  status: 'ステータス',
  search: '検索',
  sender: '送信者',
  social: 'ソーシャル',
  signUp: 'サインアップ',
  stopHinting: 'ヒントを表示しない',
  submit: '提出',
  setting: '設定',
  success: '成功',
  settings: '設定',
  senderId: '送信者ID',
  secretKey: '秘密鍵',
  selectAll: 'すべて選択',
  superUser: 'スーパーユーザー',
  shortName: '略称',
  searchKey: 'キーワード',
  shareCode: '共有コード',
  subAgents: 'サブエージェント',
  syncAgent: 'エージェントを同期',
  senderRole: '送信者の役割',
  signedDate: '署名日',
  socialDetail: 'ソーシャル',
  signedStatus: '署名ステータス',
  successMin: '最小成功回数',
  systemConfig: 'システム設定',
  selectedCount: '選択済み（{count}）',
  systemFeeModel: 'システム手数料モデル',
  systemFeeValue: 'システム手数料設定値',
  syncInstitution: '機関を同期',
  settlementCurrency: '決済通貨',
  statusInfo: 'Status Info',

  /* T */
  tw: '中国語（繁体字）',
  tabs: 'タブ',
  type: 'タイプ',
  table: 'テーブル',
  token: 'トークン',
  total: '合計',
  target: 'ターゲット',
  taxNo: '税番号',
  txHash: '取引ハッシュ',
  toRefId: 'カスタマー受取アカウントID',
  tabLimit: 'タブ制限',
  transfer: '転送',
  tinTaxNo: '税金識別番号',
  toRefBank: 'カスタマー受取銀行',
  testNetwork: 'テストネットワーク',
  tax: '税金識別',
  taxDetail: '税金識別',
  taxFormType: '税務フォームの種類',
  taxFormDate: '税務フォームの日付',
  taxNoExpireDate: '税番号の有効期限',
  transaction: '取引',
  transactionProof: '転送証明',
  tronScanUrl: 'TronスキャンURL',
  toRefNumber: 'カスタマー受取アカウント',
  timedRefresh: '定期的な更新',
  tokenExpired: 'ログイン期限切れ',
  transferAmount: '転送金額',
  transferFromIt: '機関からの転送',
  tradingPassword: '取引パスワード',
  transferConfirm: '受け取り',
  transferDetails: '転送詳細',
  transactionModel: '支払モード',
  transactedAmount: '引き出し金額',
  transactionCategory: '支払方法',
  transferNotifyTimeLimit: '転送通知時間制限',

  /* U */
  userId: 'ユーザーID',
  upload: 'アップロード',
  unitCny: '元',
  username: 'ユーザー名',
  unlocked: 'ロック解除',
  unverify: '未認証',
  unchecked: '未選択',
  unprocess: '未認証',
  uncreated: '未作成',
  unapprove: '承認されていない',
  usCitizen: 'アメリカ市民かどうか',
  usResident: 'アメリカ居住者かどうか',
  usTaxPayers: 'アメリカ納税者かどうか',
  usdFeeAmount: 'System Fee',
  usBeneficiary: 'アメリカ受益者かどうか',
  usCompany: 'アメリカ企業かどうか',
  unprocessed: '未処理',
  unactivated: '未活性化',
  uploadImage: '画像をアップロード',
  uploadProof: '証明書をアップロード',
  uploadLimitation: '{types} 最大{maxSize}M',
  upstreamPaymentChannel: '上流支払いチャネル',
  unsupportedBrowserTitle: 'このブラウザはサポートされていません',
  unsupportedBrowserContent1: '最新のブラウザにアップグレードしてください。',
  unsupportedBrowserContent2: '（推奨：Chrome 90+、Safari 14+、Firefox 80+）',

  /* V */
  value: '値',
  verify: '認証',
  verify2: '承認',
  version: 'バージョン',
  validUrl: '有効なURL',
  verified: '確認済み',
  verifyId: '認証ID',
  verifyInfo: '認証情報',
  verifyName: '認証名',
  verifyApproval: '認証承認',
  visibilityHeight: '可視高さ',

  /* W */
  welcome: 'ようこそ',
  withdraw: '引き出す',
  withdrawHistory: '出金履歴',
  workflow: 'ワークフロー',
  withdrawal: '引き出し',
  waiverType: '免除のタイプ',
  withdrawalVerify: '引き出し承認',
  withdrawalAmount: '引き出し金額',
  withdrawalAmountLocal: '引き出し金額（現地通貨）',
  withdrawApproval: '引き出し承認',
  withdrawalDetail: '引き出しの詳細',
  withdrawalFlowId: '引き出しID',
  withdrawalInfo: 'Withdrawal Info',
  windowsDesktop: 'Windows Desktop',
  windowsDesktopLink: 'Windows Desktop Link',
  web: 'Web Trader',
  webLink: 'Web Trader Link',

  /* X */

  /* Y */
  yes: 'はい',
  youWillTransferForAboveAccountsSeparately: '上記のアカウントに対して別々に振り込みます',

  /* Z */
  cn: '中国語（簡体字）',

  receiverInfo: '支払先情報',
  surName: '姓',
  givName: '名前',
  middleName: 'ミドルネーム',
  otherName: '他の言語名',
  address: '住所',
  area: '携帯電話の市外局番',
  phone: '電話番号',
  cellphone: '電話番号',
  nationality: '国籍',
  idType: 'ドキュメントタイプ',
  idNumber: 'ID番号',
  locationId: 'ロケーションID',
  bankId: '銀行支店番号',
  bankName: '銀行支店名',
  bankBranchName: '支店名',
  bankBranchCode: '支店コード',
  bankBranchId: '支店ID',
  accountNo: '銀行カード番号',
  occupation: '職業',
  bankMobile: '銀行予約の携帯電話番号',
  issueDate: '書類発行日',
  expireDate: '文書の有効期限',
  licIssuAutho: '文書発行権限',
  remark: '備考',
  accountType: 'アカウントの種類',
  city: '都市',
  states: '州',
  zipCode: '郵便番号',
  country: '国',
  email: '電子メール',
  accountNumber: 'アカウント番号',
  phoneCountry: '携帯電話番号の国',
  accountCity: 'アカウントが属する都市',
  accountCountry: 'アカウントの国',
  currency: '通貨',
  userName: 'ユーザー名',
  birthday: '生年月日',
  postalCode: '郵便番号',
  provinceState: '州/県',
  cardNumber: 'カード番号',
  nativeFirstName: '元の姓',
  nativeLastName: '元の名前',
  remitterType: '支払いタイプ',
  ibanNo: '国際銀行口座番号',
  accountAddress: 'アカウントアドレス',
  routingType: 'ルーティング タイプ',
  senderBusiness: '支払い会社情報',
  registeredName: '会社の登録名',
  tradingName: '会社名',
  msisdn: '会社の連絡先番号',
  registrationNumber: '会社登録番号',
  dateOfIncorporation: '会社登録日',
  目的OfRemittance: '送金目的',
  documentReferenceNumber: '文書参照番号',
  taxId: '納税者番号',
  sourceOfFund: '資金源',
  countryCode: '国コード',
  transactionType: 'トランザクションモード',
  channelCode: 'チャンネル番号',
  beneficiaryRelationShip: '送金関係',
  gender: '性別',
  otherDownloads: 'その他のダウンロード方法',
  verifyNotice1: 'メール認証に成功しました！',
  verifyNotice2:
    '当社製品---{name}にご登録いただきありがとうございます。これで、このアカウントを使用してログイン インターフェイスにログインできるようになります。ご質問がございましたら、お気軽にカスタマー サービス チーム (https://wa.me/13234169593) までお問い合わせください。',
  verifyNotice3: '上手に使ってほしいですね ！',
  depositButtonLabel: 'PIX',
  depositNotice1: 'ヒント:',
  depositNotice2: ' 最初の入金で',
  depositNotice3: '{amount} {currency}',
  depositNotice4: 'プラットフォームは追加のボーナスを与えます',
  depositNotice5: ' {amount} {currency}',
  depositNotice6: '入金と出金の為替レートは同じです',
  liveRoom: 'ライブを見てお金を稼ぐ方法を学びます。',
  emailPassword: '電子メール',
  phonePassword: '電話番号',
  globalName: 'ASTRAL',

  cryptoTokenType: 'ブロックチェーンネットワーク',
  cryptoWalletAddress: 'ウォレットアドレス',
};
